import client from './axios';
import { setSession } from './service';

class Session {
  constructor(token, expiresIn) {
    this.token = token;
    this.expiry = new Date().getTime() + expiresIn * 1000;
  }
}

export const login = async (username, password) => {
  const response = await client.post('/auth/login', {
    email: username,
    password: password,
  });

  if (response.status === 200) {
    const data = response.data;

    if (data.type === 'AUTHENTICATION_RESULT') {
      const session = new Session(data.accessToken, data.expiresIn);
      setSession(session);
      return session;
    } else {
      throw 'Not Implemented yet';
    }
  }

  throw 'Login failed';
};

export const loginAdmin = async (username, password) => {
  const response = await client.post('/auth/login', {
    email: username,
    password: password,
  });

  if (response.status === 200) {
    const data = response.data;

    if (data.type === 'AUTHENTICATION_RESULT') {
      const session = new Session(data.accessToken, data.expiresIn);
      setSession(session);
      return session;
    } else {
      throw 'Not Implemented yet';
    }
  }

  throw 'Login failed';
};

export const registration = async (payload) => {
  const response = await client.post('/auth/register', payload);

  if (response.status === 200) {
    const data = response.data;
    return data;
  }

  throw 'Registration failed';
};

export const registrationVerification = async (payload) => {
  const response = await client.post('/auth/verify', payload);

  if (response.status === 200) {
    const data = response.data;
    return data;
  }

  throw 'Registration failed';
};

export const getResetPasswordConfirmationCode = async (email) => {
  const response = await client.post('/auth/forgot-password', {
    email: email,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const RestPassword = async (email, password, code) => {
  const response = await client.post('/auth/reset-password', {
    email,
    password,
    confirmationCode: code,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getVerificationEmailCode = async (email) => {
  const response = await client.post('/auth/resendOTP', {
    email: email,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const changePassword = async (email) => {
  const response = await client.post('/auth/change-password', {
    email: email,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
